<div class="profile flex__child--auto flex--column has-toolbar" data-test="settings">
  <mat-toolbar>
    <span class="mat-toolbar__title text--primary">{{
      'settings.third-parties.title' | translate
    }}</span>
  </mat-toolbar>
  <app-third-parties-navigation></app-third-parties-navigation>
  <div>
    <router-outlet #o="outlet"></router-outlet>
  </div>
</div>
